import ENDPOINT from "@/api/endpoints";
import {
  HTTP,
  HTTP_SCAN,
  HTTP_QLVB,
  HTTP_FILE,
  buildQueries,
} from "@/api/http-common";
import _cloneDeep from "lodash/cloneDeep";
import { formatAttachFilesData } from "@/utils/uploadFileUtils";

let qs = require("qs");
const formDataHeaderConfig = {
  headers: {
    "Content-Type": "multipart/form-data;",
  },
};

function getFormDataFromPayload(payload) {
  let formData = new FormData();
  for (let key in payload) {
    if (["NhiemVuXuLy"].indexOf(key) === -1) {
      formData.append(key, payload[key]);
    }
  }
  const NhiemVuXuLy = _cloneDeep(payload.NhiemVuXuLy);

  NhiemVuXuLy.forEach((file, index) => {
    formData = formatAttachFilesData(file, index, formData, "NhiemVuXuLy");
  });

  return formData;
}

export function callApiGetDanhSachVanBanDen(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.VAN_BAN_DEN.GET_DANH_SACH_VAN_BAN_DEN, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiGetChiTietTraCuuVanBanDen(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DEN.GET_CHI_TIET_TRA_CUU_VAN_BAN_DEN,
    method: "GET",
    params: payload,
  });
}

export function callApiGetTrangThaiVanBanDen(payload) {
 return HTTP({
    url: ENDPOINT.VAN_BAN_DEN.GET_ALL_TRANG_THAI,
    method: "GET",
    params: payload,
  });
}

export function callApiGetDashboardVanBanDen(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DEN.GET_DASHBOARD_VAN_BAN_DEN,
    method: "GET",
    params: payload,
  });
}

export function callApiSoLuongVbdById(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.VAN_BAN_DEN.GET_SO_LUONG_VAN_BAN_DEN_ID, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiGetDanhSachThuHoi(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.VAN_BAN_DEN.GET_DANH_SACH_THU_HOI}/${payload}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiThuHoi(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.VAN_BAN_DEN.THU_HOI, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiTaoQrPDF(payload) {
  return new Promise((resolve, reject) => {
    return HTTP_FILE.post(ENDPOINT.VAN_BAN_DEN.QR_PDF, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiGetDanhSachTraLai(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.VAN_BAN_DEN.GET_DANH_SACH_TRA_LAI}${payload}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiTraLai(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.VAN_BAN_DEN.TRA_LAI, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiXoaVanBan(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.delete(`${ENDPOINT.VAN_BAN_DEN.XOA_VAN_BAN}/${payload}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayLoaiVanBanDen(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.VAN_BAN_DEN.GET_LOAI_VAN_BAN_DEN}?${buildQueries(payload)}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLaySoVanBanDen(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.VAN_BAN_DEN.GET_SO_VAN_BAN_DEN}?${buildQueries(payload)}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayPhuongThucNhan(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.VAN_BAN_DEN.GET_PHUONG_THUC_NHAN_VAN_BAN, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayLoaiVanBan(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.VAN_BAN_DEN.GET_LOAI_VAN_BAN, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDoKhan(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.VAN_BAN_DEN.GET_DO_KHAN, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDonViNgoai(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.VAN_BAN_DEN.GET_DON_VI_NGOAI}?${buildQueries(payload)}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayOptionDonVi(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DEN.GET_OPT_DON_VI,
    method: "GET",
    params: payload,
  });
}

export function callApiLaySoDen(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.VAN_BAN_DEN.GET_SO_DEN}/${payload}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayChiTietVanBanDen(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.VAN_BAN_DEN.GET_CHI_TIET_VAN_BAN_DEN}?${buildQueries(
        payload
      )}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiVaoSoVanBan(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(`${ENDPOINT.VAN_BAN_DEN.VAO_SO_VAN_BAN}`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiSaoChepVanBan(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(`${ENDPOINT.VAN_BAN_DEN.SAO_CHEP_VAN_BAN}`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiVaoSoDienTu(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(`${ENDPOINT.VAN_BAN_DEN.VAO_SO_VAN_BAN_DIEN_TU}`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiCapNhatVanBanDenDangThucHien(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(`${ENDPOINT.VAN_BAN_DEN.CAP_NHAT_DANG_THUC_HIEN}`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiScanVanBan(payload) {
  let formData = new FormData();
  formData.append("file", payload[0].file);
  return new Promise((resolve, reject) => {
    return HTTP_SCAN.post(
      ENDPOINT.VAN_BAN_DEN.SCAN_VAN_BAN,
      formData,
      formDataHeaderConfig
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiUploadFile(payload) {
  const formData = getFormDataFromPayload(payload);
  return new Promise((resolve, reject) => {
    return HTTP_FILE.post(
      ENDPOINT.VAN_BAN_DEN.THEM_MOI_FILE,
      formData,
      formDataHeaderConfig
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiUploadMultiFile(payload) {
  const formData = getFormDataFromPayload(payload);
  return new Promise((resolve, reject) => {
    return HTTP_FILE.post(
      ENDPOINT.VAN_BAN_DEN.THEM_MOI_NHIEU_FILE,
      formData,
      formDataHeaderConfig
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachGuiNhan(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.VAN_BAN_DEN.LICH_SU_GUI_NHAN}/${payload}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachLichSuVanBanDen(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.VAN_BAN_DEN.LICH_SU_BY_TYPE}?${buildQueries(payload)}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachFileVanBanDen(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.VAN_BAN_DEN.DANH_SACH_FILE}?${buildQueries(payload)}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callGetDanhSachFileByListId(payload) {
  return new Promise((resolve, reject) => {
    return HTTP_QLVB.post(
      `${ENDPOINT.VAN_BAN_DEN.DANH_SACH_FILE_BY_LIST_ID}`,
      payload
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error.response.data.message);
      });
  });
}

export function callApiSoVanBanDenMoiNhat() {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.VAN_BAN_DEN.SO_VAN_BAN_DEN_MOI_NHAT}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLaySoVanBan(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DEN.LAY_SO_VAN_BAN,
    method: "POST",
    data: payload,
  });
}

export function callApiButPhe(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DEN.BUT_PHE,
    method: "POST",
    data: payload,
  });
}

export function callApiLayDanhSachYKienVanBan(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.VAN_BAN_DEN.DANH_SACH_Y_KIEN}?${buildQueries(payload)}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiThemMoiYKienVanBan(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.VAN_BAN_DEN.THEM_MOI_Y_KIEN_XU_LY, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiSuaYKienVanBan(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.VAN_BAN_DEN.SUA_Y_KIEN_NHIEM_VU, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiTraLoiYKienVanBanDen(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.VAN_BAN_DEN.CHO_Y_KIEN_TRA_LOI, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiSuaXinYKienVanBanDen(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.VAN_BAN_DEN.SUA_XIN_Y_KIEN, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiXoaYKienVanBan(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.delete(
      `${ENDPOINT.VAN_BAN_DEN.XOA_Y_KIEN_NHIEM_VU}?${buildQueries(payload)}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachLuongXuLy(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.VAN_BAN_DEN.XEM_LUONG_PHAN_XU_LY}${payload}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachLuongXuLyToken(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.VAN_BAN_DEN.XEM_LUONG_PHAN_XU_LY}${payload.processId}&token=${payload.token}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiCapNhatHoanThanhYkienXuLy(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(
      `${ENDPOINT.VAN_BAN_DEN.CAP_NHAT_HOAN_THANH_Y_KIEN}`,
      payload
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiCapNhatVanBanHoiBao(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(
      `${ENDPOINT.VAN_BAN_DEN.CAP_NHAT_VAN_BAN_HOI_BAO}`,
      payload
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiSyncVanBanTuTruc() {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.VAN_BAN_DEN.SYNC_VAN_BAN_TU_TRUC)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiDongBoVanBan(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.VAN_BAN_DEN.DONG_NHAT_VAN_BAN, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiChoVaoSo(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.VAN_BAN_DEN.CHO_VAO_SO, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiDownloadExportVanBan(payload) {
  return new Promise((resolve, reject) => {
    return HTTP_FILE.post(ENDPOINT.VAN_BAN_DEN.DOWNLOAD_EXPORT, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiGetCanBoXinYKien(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.VAN_BAN_DEN.GET_NGUOI_CHO_Y_KIEN}?${buildQueries(payload)}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiGetCanBoXinYKienJson() {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.VAN_BAN_DEN.GET_NGUOI_CHO_Y_KIEN_JSON)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiXinYKienXuLy(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.VAN_BAN_DEN.XIN_Y_KIEN_XU_LY, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachLanhDaoDonVi(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.VAN_BAN_DEN.DANH_SACH_LANH_DAO_DON_VI, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachLichSuXinYKienXuLy(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.VAN_BAN_DEN.LICH_SU_XIN_Y_KIEN_XU_LY}?${buildQueries(
        payload
      )}`,
      payload
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayDanhSachNhomLamViec(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DEN.DANH_SACH_NHOM_LAM_VIEC,
    method: "GET",
    params: payload,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
  });
}

//newmision
export function callApiGetDanhSachNhomLamViecPaging(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(`${ENDPOINT.VAN_BAN_DEN.GET_LIST_NHOM_LAM_VIEC}`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiXoaNhomLamViec(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(`${ENDPOINT.VAN_BAN_DEN.XOA_NHOM_LAM_VIEC}`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiSuaNhomLamViec(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(`${ENDPOINT.VAN_BAN_DEN.SUA_NHOM_LAM_VIEC}`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiPhanXuLy(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.VAN_BAN_DEN.PHAN_XU_LY, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiThuHoiBaoCaoLanhDao(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DEN.THU_HOI_BAO_CAO_LANH_DAO,
    method: "POST",
    data: payload,
  });
}

export function callApiGetDonViXuLy(payload, checkNull) {
  return new Promise((resolve, reject) => {
    if (payload) {
      return HTTP.get(
        `${ENDPOINT.VAN_BAN_DEN.GET_PHAN_DON_VI_XU_LY}?${checkNull ? buildQueries(payload, true) : payload}`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    }
  });
}

export function callApiGetDonViXinYKien(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DEN.GET_DON_VI_XIN_Y_KIEN,
    method: "GET",
    params: payload,
  });
}

export function callApiGetAllDonViXuLy(payload, checkNull) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.VAN_BAN_DEN.CHON_NGUOI_XIN_Y_KIEN}?${checkNull ? buildQueries(payload) : payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
}

export function callApiGetDonViKyDuyet(payload, checkNull) {
  return new Promise((resolve, reject) => {
    if (payload) {
      return HTTP.get(
        `${ENDPOINT.VAN_BAN_DEN.CHON_NGUOI_KY_DUYET}?${checkNull ? buildQueries(payload) : payload}`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    }
  });
}

export function callApiGetTrangThaiVanBan(payload) {
  return new Promise((resolve, reject) => {
    if (payload) {
      return HTTP.get(`${ENDPOINT.VAN_BAN_DEN.GET_STATUS}${payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    }
  });
}

export function callApiLayDanhSachSoByDonVi(payload) {
  const queryString = Object.keys(payload)
  .map(key => `${key}=${payload[key]}`)
  .join("&");

  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.VAN_BAN_DEN.GET_SO_DEN_BY_DON_VI}?${queryString}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiTaoNhomPhanXuLy(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(`${ENDPOINT.VAN_BAN_DEN.TAO_NHOM_LAM_VIEC}`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiUpdateDsVanBanLienQuan(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.VAN_BAN_DEN.UPDATE_DS_VAN_BAN, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiGetVanBanDiResponse(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.VAN_BAN_DEN.GET_VAN_BAN_DI_RESPONSE}?processId=${payload}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiMarkAsReadByLanhDaoBo(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(
      `${ENDPOINT.VAN_BAN_DEN.MARK_AS_READ_LANH_DAO_BO}/${payload}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiTuChoi(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.VAN_BAN_DEN.TU_CHOI, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiDanhSachDonViCaNhanDuocXuLy(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DEN.DANH_SACH_DON_VI_CA_NHAN_DUOC_PHAN_XU_LY,
    method: "GET",
    params: payload,
  });
}

export function callApiYeuCauThuHoi(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DEN.YEU_CAU_THU_HOI,
    method: "POST",
    data: payload,
  });
}

export function callApiYeuCauTraLai(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.YEU_CAU_TRA_LAI,
    method: "POST",
    data: payload,
  });
}

export function callApiDataPXL(payload) {
  return HTTP({
    url: `/qlvb/van-ban-den/phan-xu-ly/lay-du-lieu-da-phan-xu-ly/${payload.vanBanId}/${payload.taskId}`,
    method: "GET",
  });
}

export function callApiXemYKienPXL(payload) {
  return HTTP({
    url: `/qlvb/van-ban-den/phan-xu-ly/y-kien-da-phan-xu-ly/${payload.vanBanId}/${payload.taskId}`,
    method: "GET",
  });
}

export function callApiUpdateYeuCauCapNhat(payload) {
  return HTTP({
    url: '/vanban/cap-nhat-yeu-cau-cap-nhat-van-ban',
    method: "POST",
    data: payload,
  });
}
